import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacySnackBar } from '@angular/material/legacy-snack-bar';
import { AssessmentService } from '../../assessments/assessment.service';

@Component({
  selector: 'app-questions-list-container',
  templateUrl: './questions-list-container.component.html',
  styleUrls: ['./questions-list-container.component.scss']
})
export class QuestionsListContainerComponent {
  @Output() selectedQuestionToAssessessment = new EventEmitter<any>();
  @Output() removeQuestionFromAssessessment = new EventEmitter<any>();
  @Output() questionDeselected = new EventEmitter<any>();
  @Output() createManualQuestion = new EventEmitter<any>();
  @Output() applyFilters = new EventEmitter<any>();
  @Output() clearFilters = new EventEmitter<void>();
  @Output() searchQuestions = new EventEmitter<string>();

  previouslyGeneratedSectionExpanded = false;

  @Input() headerInfo: any = {
    title: '',
    count: '',
    description: '',
    category: ''
  };

  @Input() questionsInfo = {
    questions: [],
    type: '',
    hasActions: true,
    category: this.headerInfo?.category,
    totalQuestions: 0,
    assessmentId: '',
    isLoadingMore: false
  };

  @Input() isManualCreation: boolean = false;
  @Input() showFilters: boolean = false;
  @Input() activeTabIndex: number = 0;
  @Input() defaultFilters: any = {};

  constructor(private snackBar: MatLegacySnackBar, private assessmentService: AssessmentService) { }

  selectedMulChoiceQuestion(question): void {
    this.selectedQuestionToAssessessment.emit(question);
  }

  removeSelectedMCQ(question): void {
    this.removeQuestionFromAssessessment.emit(question);
  }

  selectedOEQ(question): void {
    this.selectedQuestionToAssessessment.emit(question);
  }

  removeSelectedOEQ(question): void {
    this.removeQuestionFromAssessessment.emit(question);
  }

  selectedCQ(question): void {
    this.selectedQuestionToAssessessment.emit(question);
  }

  removeSelectedCQ(question): void {
    this.removeQuestionFromAssessessment.emit(question);
  }

  openedPanel() {
    if (this.headerInfo.category === 'PREVIOUSLYGENERATED' &&
      this.questionsInfo.type === 'MULTIPLE_CHOICE' || this.questionsInfo.type === 'OPEN_ENDED' || this.questionsInfo.type === 'CODING') {
      this.previouslyGeneratedSectionExpanded = true;
    }
  }

  onCreateManualQuestion(): void {
    this.createManualQuestion.emit({
      questionType: this.questionsInfo.type,
      assessmentId: this.questionsInfo.assessmentId
    });
  }

  onApplyFilters(filters: any): void {
    this.applyFilters.emit(filters);
  }

  onClearFilters(): void {
    this.clearFilters.emit();
  }

  onSearchQuestions(searchTerm: string): void {
    this.searchQuestions.emit(searchTerm);
  }

  getQuestionTypeDisplayName(): string {
    switch (this.questionsInfo.type) {
      case 'MULTIPLE_CHOICE':
        return 'MCQ';
      case 'OPEN_ENDED':
        return 'Open Ended';
      case 'CODING':
        return 'Coding';
      default:
        return 'Manual';
    }
  }

  /**
   * Whether more questions can be loaded for the current list
   */
  hasMoreQuestions(): boolean {
    const loaded = this.questionsInfo?.questions?.length || 0;
    const total = this.questionsInfo?.totalQuestions || 0;
    return total > loaded;
  }

  /**
   * Emit the appropriate event to load the next page
   */
  @Output() mcqScroll = new EventEmitter<any>();
  @Output() oeqScroll = new EventEmitter<any>();
  @Output() cqScroll = new EventEmitter<any>();
  onLoadMore(): void {
    switch (this.questionsInfo.type) {
      case 'MULTIPLE_CHOICE':
        this.mcqScroll.emit();
        break;
      case 'OPEN_ENDED':
        this.oeqScroll.emit();
        break;
      case 'CODING':
        this.cqScroll.emit();
        break;
    }
  }

  get isLoadingMore(): boolean {
    return !!(this.questionsInfo as any)?.isLoadingMore;
  }
}
